import { motion } from "framer-motion";
import * as Icons from "lucide-react";

export const WhyChoose = ({ content }) => {
  const section = content.whySection;
  return (
    <section data-testid="why-choose-section" className="relative py-24 lg:py-32 bg-surface-deep">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-2xl mx-auto mb-16"
        >
          <span className="section-kicker justify-center mb-4">{section.kicker}</span>
          <h2 className="font-display font-bold text-4xl sm:text-5xl">
            {section.title}
          </h2>
          <p className="mt-5 text-white/60 italic">
            {section.description}
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {section.items.map((c, i) => {
            const Icon = Icons[c.icon] || Icons.Sparkles;
            return (
              <motion.div
                key={c.title}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
                data-testid={`why-card-${i}`}
                className="glass rounded-lg p-7 hover:-translate-y-1 hover:border-brand/50 transition-all duration-300"
              >
                <Icon className="text-brand mb-4" size={28} />
                <h3 className="font-display font-semibold text-lg text-brand">{c.short}</h3>
                <p className="mt-3 text-sm text-white/60 leading-relaxed">{c.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;
